export function SanitizeDoubleByteNumber(value?: string): string {
    if (!value) return "";
    return value.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
}
